import type {CultureTypeInfo, TraitApproximation} from '../types';

import type {SupportedLanguages} from '../../types/SupportedLanguages';

import './CultureReport.css';

interface Props {
  cultureTypeName: string;
  cultureTypeInfo?: CultureTypeInfo | null;
  traitApproximations: TraitApproximation[];
  locale: SupportedLanguages;
}

export const CultureReport = ({cultureTypeName, cultureTypeInfo, traitApproximations, locale}: Props) => {
  const displayName = cultureTypeInfo?.name?.[locale] ?? cultureTypeName;
  const description = cultureTypeInfo?.description?.[locale];

  return (
    <section className='culture-report'>
      <div className='culture-report__type-card'>
        <div className='culture-report__type-header'>
          {cultureTypeInfo?.image_url && (
            <img src={cultureTypeInfo.image_url} alt='' className='culture-report__type-image' />
          )}
          <span className='culture-report__type-name'>{displayName}</span>
        </div>
        {description && <p className='culture-report__type-description'>{description}</p>}
      </div>

      <div className='culture-report__traits'>
        {traitApproximations.map(({trait, percentage}) => (
          <div key={trait} className='culture-report__trait'>
            <span className='culture-report__trait-name'>{trait}</span>
            <div className='culture-report__trait-bar-track'>
              <div className='culture-report__trait-bar-fill' style={{width: `${percentage}%`}} />
            </div>
            <span className='culture-report__trait-score'>{percentage}%</span>
          </div>
        ))}
      </div>
    </section>
  );
};
